export const environment = {
  backendUrls: {
    api: '/api',
  },
  auth0: {
    domain: 'anessa-1.eu.auth0.com',
    clientId: 'gOkSNtQgN5KKIYXUDPM0dPnsCbWe4TIQ',
    authorizationParams: {
      redirect_uri: globalThis.window.location.origin,
      scope: 'openid profile email offline_access',
      audiences: {
        api: 'https://api.anessa.com',
      },
    },
  },
};
